// extracted by mini-css-extract-plugin
export var baseButton = "_wn-0";
export var controlsArrowKeys = "_wn-1";
export var controlsResetButton = "_wn-2";
export var lightGameButton = "_wn-4 _wn-0";
export var playAgainButton = "_wn-5 _wn-0";
export var startGameButton = "_wn-3 _wn-0";